import { GzCompanySelect } from "../components";
import noElementsImage from "../app/webcomponents/assets/images/empty-states_illustration_first-use.svg";
import { GzCompanyType } from "../utils/enums";

const ManageAssociationsGrid = ({
  data,
  listOfChangedRows,
  handleAddingChangedRows,
  handleRemovingChangedRows,
  actionsToPerform,
  updateActionsToPerform,
  handleExcludedItems,
}) => {
  const displayAssociations = () => {
    if (data && data.length !== 0) {
      return data.map((association, index) => {
        let changedRowIndex = listOfChangedRows.find(
          (rowChangedIndex) => rowChangedIndex === index
        );

        return (
          <tr
            className={`align-middle cursor-pointer ${
              changedRowIndex !== undefined ? "bg-[#F3FAFE]" : ""
            } h-[56px]`}
            key={index}
            id={index}
          >
            <td
              className="col-sm-2 align-middle table-source"
              id={association.rmmCompanyId}
              style={{ whiteSpace: "pre-wrap" }}
            >
              {association.rmmType === 2 ? (
                <div className="flex flex-row items-center gap-2">
                  <span className="ml-6">{association.rmmCompanyName}</span>
                </div>
              ) : (
                association.rmmCompanyName
              )}
            </td>
            <td className="col-sm-2 w-[240px] table-source">
              <GzCompanySelect
                index={index}
                rmmCompanyInfo={association}
                actionsToPerform={actionsToPerform}
                updateActionsToPerform={updateActionsToPerform}
                rmmCompanyInfoList={data}
                handleAddingChangedRows={handleAddingChangedRows}
                handleRemovingChangedRows={handleRemovingChangedRows}
                handleExcludedItems={handleExcludedItems}
              />
            </td>
            <td className="col-sm-1 align-middle" style={{ position: 'relative' }}>
              {(association.hasInventoryEvents || association.isDestinationDeleted) ? (
                <div className="flex w-full">
                  <gz-tooltip
                    tooltiptext={association.hasInventoryEvents ? "Issue found under Inventory Events page" : (association.isDestinationDeleted ? "Associated GravityZone company not found" : '')}
                    tooltipclass="neutral"
                  >
                    <span
                      className="ds-icon-notification_negative"
                      style={{ color: " #ffa438", fontSize: "22px" }}
                    ></span>
                  </gz-tooltip>
                </div>
              ) : '-'}
            </td>
            <td className="col-sm-2 table-source align-middle">
              {association.gravityZoneCompanyId
                ? association.companyDetails.type === GzCompanyType.PARTNER
                  ? "Partner"
                  : "Customer"
                : "-"}
            </td>
            <td className="col-sm-2 table-source align-middle">
              {association.gravityZoneCompanyId
                ? association.companyDetails.managed === true
                  ? "Yes"
                  : "No"
                : "-"}
            </td>
            <td className="col-sm-2 table-source align-middle">
              {association.gravityZoneCompanyId
                ? association.companyDetails.suspended === true
                  ? "Yes"
                  : "No"
                : "-"}
            </td>
            <td className="col-sm-2" />
          </tr>
        );
      });
    }
  };

  return (
    <div className="mx-4 tableWrap overflow-y-auto border-t-1">
      {data && data.length !== 0 ? (
        <table className="table table-hover table-responsive table-text">
          <thead className="align-middle">
            <tr className="h-[56px] whitespace-pre-wrap break-keep" id="table-head">
              <th scope="col">
                VSA X organization
              </th>
              <th scope="col">
                GravityZone company
              </th>
              <th scope='col'>
                Needs attention
              </th>
              <th scope="col">
                Type
              </th>
              <th scope="col">
                Security managed by partner
              </th>
              <th scope="col">
                Company suspended
              </th>
              <th scope="col">
              </th>
            </tr>
          </thead>
          <tbody className="overflow-scroll table-auto" id="associationsData">
            {displayAssociations()}
          </tbody>
        </table>
      ) : (
        <div className="center-div">
          <img src={noElementsImage} />
          <gz-title
            fontweight="500"
            fontsize="20"
            style={{ marginBottom: "10px" }}
          >
            No results were found!
          </gz-title>
        </div>
      )}
    </div>
  );
};
export default ManageAssociationsGrid;
